<script setup lang="ts">
import IconManager from "@/core/IconManager.vue";

defineProps<{
  title: string;
  hasUnappliedFilters: boolean;
}>();
</script>

<template>
  <button
    class="flex flex-row relative justify-center items-center gap-2 p-2 bg-primary font-bold text-white rounded-xl hover:brightness-[1.05]"
  >
    <IconManager name="Filter" />
    <span
      v-if="hasUnappliedFilters"
      class="absolute -top-1 -right-1 bg-orange-500 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center"
    >
      !
    </span>
    {{ title }}
  </button>
</template>
